<template>
    <div style="position: relative; min-height: 160px;">
        <div class="bg-top navbar-light hidden-xs hidden-sm">
            <div class="container">
                <div class="row no-gutters d-flex align-items-center align-items-stretch">
                    <div class="col-md-4 d-flex align-items-center">
                        <a class="navbar-brand" href="" @click="$redirect_reload('/')"><img src="/images/logoh.png"
                                style="width: 340px;padding-top: 20px;padding-bottom: 20px;"></a>
                    </div>
                    <div class="col-lg-8 d-block" style="padding-top: 20px;">
                        <div class="row d-flex">
                            <div
                                class="col-md d-flex topper align-items-stretch py-md-4 hidden-xs hidden-sm">
                                <div class="icon d-flex"><span
                                        class="icon-paper-plane"></span></div>
                                <div class="text">
                                    <span>E-mail</span>
                                    <span><a :href="'mailto:' + emailtopo" style="color: #000000b3;">{{emailtopo}}</a></span>
                                </div>
                            </div>
                            <div
                                class="col-md d-flex topper align-items-stretch py-md-4 hidden-xs hidden-sm">
                                <div class="icon d-flex"><span
                                        class="icon-phone2"></span></div>
                                <div class="text">
                                    <span>Fone</span>
                                    <span style="padding-top: 5px;">{{telefone}}</span>
                                    <span style="padding-top: 5px;"><a :href="linktelefone3" style="color: #000000b3;">{{telefone3}}</a></span>
                                    <span style="padding-top: 5px;"><a :href="linktelefone5" style="color: #000000b3;">{{telefone5}}</a></span>
                                </div>
                            </div>
                            <div class="col-md topper d-flex align-items-center justify-content-end">
                                <p class="mb-0 d-block">
                                    <a :href="linkbtntopo" class="btn py-2 px-3 btn-primary"
                                        style="border-radius: 25px;" target="_blank">
                                        <span>{{txtbtntopo}} <img src="/images/whattsico.png"
                                                style="width: 20px;" /></span>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END nav -->
        <b-navbar toggleable="md"
            class="navbar navbar-expand-lg navbar-dark ftco-navbar-light d-flex align-items-center">
            <div class="container">
                <b-navbar-brand class="navbar-brand hidden-lg hidden-md" href="" @click="$redirect_reload('/')">
                    <a href="" @click="$redirect_reload('/')">
                        <img src="/images/logoh.png" alt=""
                            style="width: 280px;padding-top: 10px;padding-bottom: 10px;"></a>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <form action="#" class="searchform order-lg-last">
                    <div class="form-group d-flex">
                        <input type="text" v-model="textobusca" @keyup.enter="ValidaBusca()" class="form-control pl-3"
                            placeholder="Pesquisa">
                        <button @click.prevent="ValidaBusca()" placeholder="" class="form-control search">
                            <span class="ion-ios-search"></span></button>
                    </div>
                </form>
                <b-collapse class="collapse navbar-collapse" id="nav-collapse" is-nav>
                    <b-navbar-nav class="navbar-nav mr-auto">
                         <!--<b-nav-item class="" href="" @click="$redirect_reload('/')" style="padding-top: 0px;">Home
                        </b-nav-item> 
                        <b-nav-item class="" href="" @click="$redirect_reload('/sobre')" style="padding-top: 0px;">
                            Sobre</b-nav-item>-->
                        <b-nav-item class="" href="" @click="$redirect_reload('/produtos')" style="padding-top: 0px;">
                            Conheça nossos Produtos</b-nav-item>
                        <!-- <b-nav-item class="" href="" @click="$redirect_reload('/blog')" style="padding-top: 0px;">Blog</b-nav-item> -->
                        <b-nav-item class="" href="" @click="$redirect_reload('/contato')" style="padding-top: 0px;">
                            Contato</b-nav-item>
                        <!-- <b-nav-item class="" href="" v-if="usuario == ''" @click="$redirect_reload('/login')" style="padding-top: 0px;">Login</b-nav-item>
                        <b-nav-item class="" href="" v-else @click="Logout()" style="padding-top: 0px;">Logout</b-nav-item> -->
                        <b-nav-item class="" href="" @click="$redirect('/carrinho')" style="padding-top: 0px;">Meu
                            Carrinho <i class="fa fa-shopping-cart" style="font-size: 20px;color: #FFFFFF;"></i>
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>
<script>
export default {
    data() {
        return {
            textobusca:'',
            usuario: {},
            WhatsFlutuante: [],
            cabecalho: [],
            telefone: '',
            telefone3: '',
            linktelefone3:'',
            telefone5: '',
            linktelefone5:'',
            emailtopo: '',
            txtbtntopo: '',
            linkbtntopo: '',
        };
    },
    methods: {
        CheckLogin() {
            let usuarioTmp = {
                email: '',
                senha: '',
            }
            usuarioTmp = JSON.parse(this.$cookie.get(this.$UsuarioCookie));
            if (usuarioTmp != null) {
                let _usuario = {
                    email: usuarioTmp.email,
                    senha: usuarioTmp.senha,
                };
                this.$http.post(this.$apiUrl + "/clientes/login", _usuario).then(
                    (response) => {
                        // get body data
                        this.usuario = response.body;
                    },
                    (response2) => {
                        // error callback
                        this.$mensagem_erro(response2.body);

                    }
                );
            }
            else {
                this.usuario = '';
            }
        },
        Logout() {
            this.$cookie.delete(this.$UsuarioCookie);
            localStorage.removeItem(this.$UsuarioDados);
            this.$redirect_reload("/");
        },
        ValidaBusca() {
            if (this.textobusca != '') {
                this.$redirect_reload("/produtos/" + this.textobusca);
            }
            else {
                this.$mensagem_normal("Digite uma palavra-chave e clique na lupa para pesquisar.");
            }

        },
    },
    created() {
        //this.CheckLogin();

        this.$http
            .get(this.$apiUrl + "/institucional/telas/whatsflutuante")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.WhatsFlutuante = tiu2;
            });

        this.$http
            .get(this.$apiUrl + "/institucional/telas/cabeçalho")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.cabecalho = tiu2;
                if (this.cabecalho != '') {
                    this.telefone = this.cabecalho[0].campoExtra2
                    this.telefone3 = this.cabecalho[0].campoExtra3
                    this.telefone5 = this.cabecalho[0].campoExtra5
                    this.linktelefone3 = this.cabecalho[0].campoExtra4
                    this.linktelefone5 = this.cabecalho[0].campoExtra6
                    this.emailtopo = this.cabecalho[0].campoExtra1
                    this.txtbtntopo = this.cabecalho[0].textoBtn1
                    this.linkbtntopo = this.cabecalho[0].linkBtn1
                }
            });

        /*  
        
        this.$http
             .get(this.$apiUrl + "/institucional/telas/informacoes")
             .then((res2) => res2.json())
             .then((tiu2) => {
                 this.informacoes = tiu2;
                 if (this.informacoes != '') {
                     this.telefone = this.informacoes[0].nome
                     this.Linktelefone = this.informacoes[0].referencia
                 }
             });
        
        
        this.$http
             .get(this.$apiUrl + "/institucional/telas/facebook")
             .then((res2) => res2.json())
             .then((tiu2) => {
                 if (tiu2 != '') {
                     this.Face = tiu2
                 }
 
             });
 
         this.$http
             .get(this.$apiUrl + "/institucional/telas/instagram")
             .then((res2) => res2.json())
             .then((tiu2) => {
                 if (tiu2 != '') {
                     this.Insta = tiu2
                 }
             });
 
         this.$http
             .get(this.$apiUrl + "/institucional/telas/youtube")
             .then((res2) => res2.json())
             .then((tiu2) => {
                 if (tiu2 != '') {
                     this.Yout = tiu2
                 }
             });
 
         this.$http
             .get(this.$apiUrl + "/institucional/telas/linkedin")
             .then((res2) => res2.json())
             .then((tiu2) => {
                 if (tiu2 != '') {
                     this.Linke = tiu2
                 }
             }); */

    },
    mounted() {

    },
    components: {
    },
};
</script>

<style>
/* WHATSAPP FIXO */
.whatsapp-fixo {
    position: fixed;
    bottom: 2%;
    right: 0px;
    z-index: 99999999;
}

/* .navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
    align-items: baseline !important;
}

.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
} */

@media (max-width:767px) {
    .hidden-xs {
        display: none !important;
    }
}

@media (min-width:768px) and (max-width:991px) {
    .hidden-sm {
        display: none !important;
    }
}

@media (min-width:992px) and (max-width:1199px) {
    .hidden-md {
        display: none !important;
    }
}

@media (min-width:1200px) {
    .hidden-lg {
        display: none !important;
    }
}
</style>

